import { ArtTabs } from "@art/shared-ui"
import { Box } from "@mui/material"
import { Outlet, useLocation } from "react-router-dom"
import { usePageWrapper } from "../../../hooks"
import { useAttributePermission } from "../../permissions"

const ApplicationUsers = () => {

    const location = useLocation();
    const canViewUsers = useAttributePermission("PLATFORM_SETTINGS", "USER_MANAGEMENT", "ViewUsers");
    const canViewInvites = useAttributePermission("PLATFORM_SETTINGS", "USER_MANAGEMENT", "ViewInvitations");
    return <div>
        <ArtTabs tabs={[
            canViewUsers && {
                label: "Users",
                route: "/platform-settings/application-users/users"
            },
            canViewInvites && {
                label: "Invites",
                route: "/platform-settings/application-users/invite-users"
            }
        ].filter(Boolean) as any}
        currentPath={location.pathname}
        />
        <Box sx={{ py: '30px' }}>
            <Outlet />
        </Box>
    </div>
}

export default usePageWrapper(ApplicationUsers, {
    page_title: "Application Users"
})
